import { render } from "./ManajemenView.vue?vue&type=template&id=b00460ce"
import script from "./ManajemenView.vue?vue&type=script&lang=js"
export * from "./ManajemenView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__